import { QueryClient } from '@tanstack/react-query';
import { QueryClientProvider as QueryProvider } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

// React Query's own default is `retry: 3`, meaning 3 retries after the first attempt. Kept
// verbatim so this predicate changes exactly one thing and does not quietly shrink the budget
// for the ~130 queries that never opted out.
const MAX_RETRIES = 3;

// Exported for its test. A 401 has already been through request.service's interceptor, which
// refreshed and replayed, so every extra attempt is a duplicate of work that already failed.
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (isAxiosError(error) && error.response?.status === 401) return false;
  return failureCount < MAX_RETRIES;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: shouldRetry,
    },
  },
});

export function QueryClientProvider({ children }: { children?: React.ReactNode }) {
  return <QueryProvider client={queryClient}>{children}</QueryProvider>;
}
